<template>
  <div class="base-wrap page-welcome">
    <div class="slogan">欢迎使用</div>
    <div class="slogan">PaaS配置后台</div>
  </div>
</template>

<script>
export default {
  name: "welcome",
  data() {
    return {
      radio: 3,
      outerVisible: false,
      innerVisible: false,
      pagination: {
        currPage: 2,
        pageSize: 20,
        total: 211
      }
    };
  }
};
</script>
<style lang="scss" scoped>
@import "@/styles/media-queries.scss";

.page-welcome {
  border: 0 !important;
  background-image: url(~@/assets/images/bgi_welcome.png);
  background-position: right 130px bottom 50px;
  background-repeat: no-repeat;

  padding: {
    left: 125px;
    right: 96px;
    top: 140px;
    bottom: 152px;
  }
  @include zoom {
    background-position: 180px 300px;
    padding: {
      left: 28px;
      right: 0px;
      top: 48px;
      bottom: 0px;
    }
    .text {
      display: none;
    }
  }

  .slogan {
    line-height: 80px;
    font-size: 48px;
    color: #018ddd;
  }
}
</style>

